import { CountryNominationSummary } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getCountryAwardNominationSummaries: (
  fetchContext: FetchContext,
  programId: number, 
  countryId: number, 
  searchText?: string,
  accessToken?: string,
) => Promise<CountryNominationSummary[]> = (fetchContext, programId, countryId, searchText, accessToken) => {
  const params = new URLSearchParams();
  if (searchText && searchText.length > 0) params.append('searchText', searchText);

  return fetch(`${fetchContext.baseUrl}/api/staff/programs/${programId}/countries/${countryId}/nomination-summaries${params.size > 0 ? `?${params}` : ''}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => responseErrorHandler<CountryNominationSummary[]>(fetchContext.errorStore, response, 'get country award nomination summaries'));
};
